import { createContext, useContext, useMemo, useState } from 'react';
import AuthModal from '../components/AuthModal';

const AuthDialogContext = createContext(null);

export const useAuthDialog = () => {
  const context = useContext(AuthDialogContext);
  if (!context) {
    throw new Error('useAuthDialog must be used within an AuthDialogProvider');
  }
  return context;
};

export const AuthDialogProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState('login');

  const openAuth = (nextMode = 'login') => {
    setMode(nextMode);
    setIsOpen(true);
  };

  const closeAuth = () => {
    setIsOpen(false);
  };

  const value = useMemo(
    () => ({
      closeAuth,
      isOpen,
      mode,
      openAuth,
    }),
    [isOpen, mode],
  );

  return (
    <AuthDialogContext.Provider value={value}>
      {children}
      <AuthModal isOpen={isOpen} onClose={closeAuth} initialMode={mode} />
    </AuthDialogContext.Provider>
  );
};

export default AuthDialogContext;
